import { motion, AnimatePresence } from "motion/react";
import { Loader2 } from "lucide-react";
import { EASE } from "@/shared/motion/transitions";

/** Slide-up save bar shown when a settings section has unsaved changes. */
export default function StickySaveBar({
  visible,
  saving,
  onSave,
  onDiscard,
}: {
  visible: boolean;
  saving?: boolean;
  onSave: () => void;
  onDiscard: () => void;
}) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.25, ease: EASE }}
          className="sticky bottom-4 z-20 mt-6 flex items-center justify-between gap-3 rounded-2xl border border-ink-100 bg-white/95 px-4 py-3 shadow-pop backdrop-blur"
        >
          <span className="text-[12.5px] font-medium text-ink-600">You have unsaved changes</span>
          <div className="flex items-center gap-2">
            <button onClick={onDiscard} className="rounded-lg px-3 py-1.5 text-[12.5px] font-medium text-ink-500 hover:text-ink-800">
              Discard
            </button>
            <button
              onClick={onSave}
              disabled={saving}
              className="btn-press flex items-center gap-1.5 rounded-lg bg-ink-900 px-4 py-1.5 text-[12.5px] font-semibold text-white hover:bg-ink-800 disabled:opacity-50"
            >
              {saving ? <Loader2 size={13} className="animate-spin" /> : null} Save changes
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
